import React from "react";

const Feature = () => {
  return (
    <div className="container-fluid overflow-hidden py-5 px-lg-0">
      <div className="container feature py-5 px-lg-0">
        <div className="row g-5 mx-lg-0">
          <div
            className="col-lg-6 feature-text wow fadeInUp"
            data-wow-delay="0.1s"
          >
            <h6 className="text-secondary text-uppercase mb-3">Our Features</h6>
            <h1 className="mb-5">
              We Are Trusted Logistics Company Since 1990
            </h1>
            <div className="d-flex mb-5 wow fadeInUp" data-wow-delay="0.3s">
              <i className="fa fa-map-marker-alt text-primary fa-3x flex-shrink-0"></i>
              <div className="ms-4">
                <h5>Reliable Service Coverage</h5>
                <p className="mb-0">
                  Providing seamless transport solutions across our service
                  network with reliability and efficiency.
                </p>
              </div>
            </div>
            <div className="d-flex mb-5 wow fadeIn" data-wow-delay="0.5s">
              <i className="fa fa-shipping-fast text-primary fa-3x flex-shrink-0"></i>
              <div className="ms-4">
                <h5>On Time Delivery</h5>
                <p className="mb-0">
                  Ensuring your shipments arrive safely and punctually, every
                  time, with our reliable and efficient logistics solutions.
                </p>
              </div>
            </div>
            <div className="d-flex mb-0 wow fadeInUp" data-wow-delay="0.7s">
              <i className="fa fa-headphones text-primary fa-3x flex-shrink-0"></i>
              <div className="ms-4">
                <h5>24/7 Telephone Support</h5>
                <p className="mb-0">
                  Always here for you with round-the-clock assistance to address
                  all your logistics needs.
                </p>
              </div>
            </div>
          </div>
          <div
            className="col-lg-6 pe-lg-0 wow fadeInRight"
            data-wow-delay="0.1s"
            style={{ minHeight: "400px" }}
          >
            <div className="position-relative h-100">
              <img
                className="position-absolute img-fluid w-100 h-100"
                src="/assets/img/feature.jpg"
                style={{ objectFit: "cover" }}
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Feature;
